export const NAME_REGEX = /^[A-Za-z'\-\s]+$/

// used to validate name fields with protected components
export const PROTECTED_NAME_REGEX = /^(?:[A-Za-z][A-Za-z'\-\s]*|[A-Za-z]\*+)$/
